<template>
  <button
    class="rounded-button btn-transparent transition-fast"
    :class="{'hide-text': compact}"
    @click="handleClick"
  >
    <span class="icon-wrapper button transition-fast " :class="btnType">
          <slot name="icon">
      <!-- Fallback Icon-->
      <i class="fallback-icon" :class="icon"></i>
    </slot>
    </span>
    <span class="paragraph text transition-fast">
      <slot></slot>
    </span>
  </button>
</template>

<script>
import BootstrapTypes from "../enums/BootstrapTypes";

export default {
  name: "RoundedButton.vue",
  props: {
    compact: {
      required: false,
      type: Boolean,
      default: false,
    },
    outline: {
      required: false,
      default: false,
      type: Boolean,
    },
    icon: {
      required: false,
      type: String,
    },
    href: {
      type: String,
      required: false,
    },
    type: {
      validator(value) {
        return Object.values(BootstrapTypes).includes(value);
      },
      default() {
        return BootstrapTypes.primary
      }
    }
  },
  computed: {
    btnType() {
      return 'button-' + (this.outline ? 'outline-' : '') +  this.type ;
    }
  },
  methods:{
    handleClick() {
      this.$emit('click');
      if ( this.href ){
        this.navigator.navigatePath(this.href);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

button {
  display: flex;
  align-items: center;
  min-height: 40px;

  font-size: $font-size-small;
  gap: $spacing-xs;
  .icon-wrapper {
    border-radius: 9999px;
    padding: $spacing-xs;
    width: $spacing-xl;
    height: $spacing-xl;
    display: flex;
    i {
      margin: auto;
      font-size: 13px;
    }
  }

}


.border {
  border: 1px solid;
}
</style>
